// 商品抽獎 資訊

import DrawItemCountdown from '@/components/draw/DrawItemCountdown'; // 截止倒數
import ItemAmountSelect from '@/components/item/ItemAmountSelect'; // 投入數量

interface Props {
    item: any;
    amount: number;
    setAmount: (amount: number) => void;
}

const DrawItemInfo = ({ item = {}, amount, setAmount }: Props) => {
    const { name = '', shortDesc = '' } = item || {};
    return (
        <div className="space-y-5.5">
            {/* 商品名稱 */}
            <h2 className="text-h3 text-black9">{name}</h2>

            {/* 截止倒數 */}
            <DrawItemCountdown item={item} />

            {/* 商品描述 */}
            <div className="max-w-full whitespace-pre-wrap wrap-break-word text-black8 text-bd4n lg:line-clamp-2">
                {shortDesc}
            </div>

            {/* 投入數量 */}
            <ItemAmountSelect item={item} amount={amount} setAmount={setAmount} />
        </div>
    );
};

export default DrawItemInfo;
